import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ProcessSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="process" className="bg-white py-20 lg:py-28" ref={ref} data-id="element-427" data-mp="3qvxlpg7cvf82">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-428" data-mp="3vso2k5qzieuj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        ease: EASE
      }} className="max-w-[44rem]" data-id="element-429" data-mp="3pn2zfskf9t2">
          <h2 className="esca-h2 text-ink text-balance" data-id="element-430" data-mp="1f527r5r0n5yq">{c.process.title}</h2>
          <p className="esca-lead mt-6 text-muted max-w-[54ch]" data-id="element-431" data-mp="1f76fxzvy6r4t">
            {c.process.lead}
          </p>
        </motion.div>

        <ol className="mt-14 lg:mt-16 grid sm:grid-cols-2 lg:grid-cols-6 border-t border-l border-line" data-id="element-432" data-mp="y8rieakkr83z">
          {c.process.steps.map((step, i) => <motion.li key={step} initial={{
          opacity: 0,
          y: 12
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.45,
          delay: 0.08 + i * 0.05,
          ease: EASE
        }} className="relative border-r border-b border-line px-6 py-8 lg:py-10" data-id="element-433" data-mp="t727qw19kwgf" data-mpi={i}>
              <span className="font-display text-sm font-semibold tabular-nums text-accent" data-id="element-434" data-mp="agkij1fn4izt">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 font-display text-lg font-semibold text-ink tracking-[-0.02em] leading-snug" data-id="element-435" data-mp="lis829mpavn">
                {step}
              </h3>
            </motion.li>)}
        </ol>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        delay: 0.3,
        ease: EASE
      }} className="mt-14 lg:mt-16 grid lg:grid-cols-[auto_1fr] gap-6 lg:gap-14 items-center bg-sand px-7 py-9 lg:px-12 lg:py-12" data-id="element-436" data-mp="3nq8iqjpku9fy">
          <div data-id="element-437" data-mp="34586nzdnb7nn">
            <div className="font-display text-[3rem] lg:text-[4.5rem] font-bold text-ink tracking-[-0.045em] leading-none" data-id="element-438" data-mp="345qcnnq4108r">
              {c.process.timeValue}
            </div>
            <div className="mt-3 text-[0.9375rem] text-muted" data-id="element-439" data-mp="nglp4xxfnyy">
              {c.process.timeLabel}
            </div>
          </div>
          <p className="text-[0.9375rem] text-muted leading-relaxed max-w-[46ch] lg:border-l lg:border-line lg:pl-14" data-id="element-440" data-mp="3n29dlpqrfhu8">
            {c.process.timeCaveat}
          </p>
        </motion.div>
      </div>
    </section>;
}